// extracted by mini-css-extract-plugin
export default {"promotions_container":"style_promotions_container__EI8pd","subheader":"style_subheader__vOMRm","products_card":"style_products_card__GAV9Q"};